import { Navigate, Route, Routes } from "react-router";
import Posts from "./Posts";
import BlogHome from "./Home";
export default function Blog() {
    return(
        <div id="wd-Posts" className="row justify-content-center me-3 ms-3 pb-3 pt-1">
        <div className="col-sm-1 col-md-1 col-lg-1">
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10">  
        <Routes>
            <Route path="/" element={<BlogHome/>}/>
            <Route path=":bid/*" element={<Posts/>} />
        </Routes>
        </div>
        <div className="col-sm-1 col-md-1 col-lg-1 mb-3">
        </div>
        </div>
    );
}